<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card class="mt-2 pb-8 mb-5" flat>
					<v-card-title>
						<v-subheader>
							<span class="title font-weight-normal"
								>Filtrar diagnostico</span
							>
						</v-subheader>
						<v-spacer></v-spacer>
						<v-btn
							class="white--text mr-2"
							depressed
							color="#34bfa3"
							@click="$router.push('/diagnostic/new')"
							>+ Novo</v-btn
						>
						<v-btn
							class="white--text"
							depressed
							color="info"
							@click="filter()"
							>Buscar</v-btn
						>
						<search-filter-default
							v-model="filters"
							@search="filter()"
						/>
					</v-card-title>
				</v-card>
				<v-card flat>
					<v-data-table
						:headers="headers"
						:items="items"
						:items-per-page="pagination.itemsPerPage"
						v-bind:loading="loading"
						loading-text="Aguarde...carregando"
						:hide-default-footer="true"
						:footer-props="{
							'items-per-page-text': 'Itens por página',
							'items-per-page-all-text': 'Todos'
						}"
					>
						<template v-slot:body="{ items }">
							<tr v-for="item in items" :key="item.CODDIA">
								<td>
									<v-btn @click="edit(item.CODDIA)" icon>
										<v-icon style="color: orange"
											>mdi-pencil</v-icon
										>
									</v-btn>
								</td>
								<td>{{ item.CODDIA }}</td>
								<td>{{ item.strategicplanning.DESABR }}</td>
								<td>{{ item.company.DESABR }}</td>
								<td>{{ item.unit.DESABR }}</td>
								<td>
									{{
										item.AMBIEN === "I"
											? "Interno"
											: item.AMBIEN === "E"
											? "Externo"
											: ""
									}}
								</td>
								<td>
									{{
										item.TIPO === "O"
											? "Força"
											: item.TIPO === "R"
											? "Fraqueza"
											: item.TIPO === "P"
											? "Oportunidades"
											: item.TIPO === "M"
											? "Ameaças"
											: ""
									}}
								</td>
								<td>{{ item.DESDIA }}</td>
								<td>
									<v-btn @click="remove(item.CODDIA)" icon>
										<v-icon style="color: red"
											>mdi-delete</v-icon
										>
									</v-btn>
								</td>
							</tr>
						</template>
					</v-data-table>

					<pagination
						v-model="pagination"
						@change="loadData"
						:loading="loading"
					/>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import DiagnosticService from "../../app/Services/DiagnosticService";
import pagination from "@/components/pagination/Pagination.vue";
import PaginationMixin from "@/components/pagination/PaginationMixin";
import SortableMixin from "@/components/pagination/sort/SortableMixin";
import searchFilterDefault from "@/components/searchFilterDefault/searchFilterDefault.vue";

export default {
	name: "DiagnosticList",
	computed: {},
	components: { searchFilterDefault, pagination },
	mixins: [PaginationMixin, SortableMixin],
	mounted() {
		this.loadData();
	},
	data: () => ({
		loading: false,
		filters: {
			description: ""
		},
		headers: [
			{
				text: "",
				align: "left",
				sortable: false,
				value: "",
				width: "3%"
			},
			{
				text: "Código",
				align: "left",
				sortable: true,
				value: "CODDIA",
				width: "10%"
			},
			{
				text: "Planej.",
				align: "left",
				sortable: true,
				value: "strategicplanning.DESABR",
				width: "10%"
			},
			{
				text: "Empresa",
				align: "left",
				sortable: true,
				value: "item.company.DESABR",
				width: "10%"
			},
			{
				text: "Unidade",
				align: "left",
				sortable: true,
				value: "item.unit.DESABR",
				width: "10%"
			},
			{
				text: "Ambiente",
				align: "left",
				sortable: true,
				value: "AMBIEN",
				width: "10%"
			},
			{
				text: "Tipo",
				align: "left",
				sortable: true,
				value: "TIPO",
				width: "10%"
			},
			{
				text: "Descrição",
				align: "left",
				sortable: true,
				value: "DESDIA"
			},
			{
				text: "",
				align: "left",
				sortable: false,
				value: "",
				width: "3%"
			}
		],
		items: []
	}),
	methods: {
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon
			});
		},
		async loadData() {
			try {
				this.loading = true;

				const filter = this.filters;

				const query = {
					params: {
						filter,
						...this.pagination
					}
				};

				const response = await DiagnosticService.build().index({
					query
				});

				this.items = response.data;
				this.loading = false;

				this.paginate(response);
			} catch (e) {
				// eslint-disable-next-line no-console
				console.log(e);
				this.defaultCatchError(e);
			} finally {
				this.loading = false;
			}
		},
		filter() {
			this.searching = true;
			this.items = [];
			this.pagination.page = 1;

			this.loadData();
		},
		edit(id) {
			this.$router.push({
				name: "DiagnosticEdit",
				params: {
					id: id
				}
			});
		},
		remove(id) {
			DiagnosticService.build()
				.destroy({
					id: id
				})
				.then(() => {
					this.toast("success", "Diagnostico removido com sucesso!");

					this.loadData();
				});
		}
	}
};
</script>
